import React, { useState, useEffect } from 'react';
import './Dishes.css';

const Dishes = () => {
  const [dishes, setDishes] = useState([]);
  const [dishName, setDishName] = useState('');
  const [calories, setCalories] = useState('');
  const [protein, setProtein] = useState('');
  const [carbs, setCarbs] = useState('');
  const [fat, setFat] = useState('');

  const [totalCalories, setTotalCalories] = useState(0);
  const [totalProtein, setTotalProtein] = useState(0);
  const [totalCarbs, setTotalCarbs] = useState(0);
  const [totalFat, setTotalFat] = useState(0);

  const handleAddDish = () => {
    if (!dishName || !calories || !protein || !carbs || !fat) return;

    const newDish = {
      name: dishName,
      calories: parseInt(calories),
      protein: parseInt(protein),
      carbs: parseInt(carbs),
      fat: parseInt(fat),
    };

    setDishes([...dishes, newDish]);

    setDishName('');
    setCalories('');
    setProtein('');
    setCarbs('');
    setFat('');
  };

  useEffect(() => {
    const totals = dishes.reduce(
      (acc, dish) => {
        acc.calories += dish.calories;
        acc.protein += dish.protein;
        acc.carbs += dish.carbs;
        acc.fat += dish.fat;
        return acc;
      },
      { calories: 0, protein: 0, carbs: 0, fat: 0 }
    );

    setTotalCalories(totals.calories);
    setTotalProtein(totals.protein);
    setTotalCarbs(totals.carbs);
    setTotalFat(totals.fat);
  }, [dishes]);

  return (
    <div className="dishes-container">
      <header className="header">
        <h1>Calorie Tracker</h1>
      </header>
      <main className="main">
        <div className="form-container">
          <input
            type="text"
            value={dishName}
            onChange={(e) => setDishName(e.target.value)}
            placeholder="Enter dish name"
          />
          <input
            type="number"
            value={calories}
            onChange={(e) => setCalories(e.target.value)}
            placeholder="Calories"
          />
          <input
            type="number"
            value={protein}
            onChange={(e) => setProtein(e.target.value)}
            placeholder="Protein (g)"
          />
          <input
            type="number"
            value={carbs}
            onChange={(e) => setCarbs(e.target.value)}
            placeholder="Carbs (g)"
          />
          <input
            type="number"
            value={fat}
            onChange={(e) => setFat(e.target.value)}
            placeholder="Fat (g)"
          />
          <button onClick={handleAddDish}>Add Dish</button>
        </div>
        <div className="dishes-list">
          <h2>Dishes List</h2>
          <ul>
            {dishes.map((dish, index) => (
              <li key={index} className="dish-item">
                <div className="dish-name">{dish.name}</div>
                <div className="dish-details">
                  <span>Calories: {dish.calories}</span>
                  <span>Protein: {dish.protein}g</span>
                  <span>Carbs: {dish.carbs}g</span>
                  <span>Fat: {dish.fat}g</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="total-calculator">
          <h2>Total Nutritional Information</h2>
          <p>Total Calories: {totalCalories}</p>
          <p>Total Protein: {totalProtein}g</p>
          <p>Total Carbs: {totalCarbs}g</p>
          <p>Total Fat: {totalFat}g</p>
        </div>
      </main>
      <footer>
        <p>&copy; Nutritional Tracker 2024. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Dishes;
